// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PresignDocumentUpload200Response
 */
export interface PresignDocumentUpload200Response {
    /**
     * 
     * @type {string}
     * @memberof PresignDocumentUpload200Response
     */
    content_type?: string;
    /**
     * 
     * @type {number}
     * @memberof PresignDocumentUpload200Response
     */
    expires_in?: number;
    /**
     * 
     * @type {number}
     * @memberof PresignDocumentUpload200Response
     */
    max_file_size?: number;
    /**
     * 
     * @type {string}
     * @memberof PresignDocumentUpload200Response
     */
    s3_key?: string;
    /**
     * 
     * @type {string}
     * @memberof PresignDocumentUpload200Response
     */
    upload_id?: string;
    /**
     * 
     * @type {string}
     * @memberof PresignDocumentUpload200Response
     */
    upload_url?: string;
}

/**
 * Check if a given object implements the PresignDocumentUpload200Response interface.
 */
export function instanceOfPresignDocumentUpload200Response(value: object): value is PresignDocumentUpload200Response {
    return true;
}

export function PresignDocumentUpload200ResponseFromJSON(json: any): PresignDocumentUpload200Response {
    return PresignDocumentUpload200ResponseFromJSONTyped(json, false);
}

export function PresignDocumentUpload200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PresignDocumentUpload200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'content_type': json['content_type'] == null ? undefined : json['content_type'],
        'expires_in': json['expires_in'] == null ? undefined : json['expires_in'],
        'max_file_size': json['max_file_size'] == null ? undefined : json['max_file_size'],
        's3_key': json['s3_key'] == null ? undefined : json['s3_key'],
        'upload_id': json['upload_id'] == null ? undefined : json['upload_id'],
        'upload_url': json['upload_url'] == null ? undefined : json['upload_url'],
    };
}

export function PresignDocumentUpload200ResponseToJSON(json: any): PresignDocumentUpload200Response {
    return PresignDocumentUpload200ResponseToJSONTyped(json, false);
}

export function PresignDocumentUpload200ResponseToJSONTyped(value?: PresignDocumentUpload200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'content_type': value['content_type'],
        'expires_in': value['expires_in'],
        'max_file_size': value['max_file_size'],
        's3_key': value['s3_key'],
        'upload_id': value['upload_id'],
        'upload_url': value['upload_url'],
    };
}
